<template>
  <div class="auth-page">
    <div class="auth-card">
      <h1>Восстановление пароля</h1>
      <p class="auth-note">Если аккаунт есть, мы отправим ссылку для сброса. Без почтового сервера ссылка появится здесь в режиме отладки и в логе сервера.</p>
      <p v-if="error" class="auth-error">{{ error }}</p>
      <p v-if="message" class="auth-note">{{ message }}</p>
      <router-link v-if="resetPath" :to="resetPath">Открыть форму нового пароля</router-link>
      <q-input outlined v-model="email" type="email" label="Email" @keyup.enter="submit" />
      <q-btn color="primary" label="Отправить ссылку" :loading="loading" @click="submit" />
      <div class="auth-links">
        <router-link to="/login">Вернуться ко входу</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import grpc from "@/services/grpc";

export default {
  name: 'ForgotPasswordView',
  data() {
    return {
      email: '',
      error: '',
      message: '',
      resetPath: '',
      loading: false,
      grpcClient: new grpc(),
    };
  },
  methods: {
    async submit() {
      this.error = '';
      this.message = '';
      this.resetPath = '';
      this.loading = true;
      try {
        const response = await this.grpcClient.requestPasswordReset(this.email);
        this.message = 'Если аккаунт существует, ссылка для сброса подготовлена.';
        if (response.devResetToken) {
          this.resetPath = '/reset-password?token=' + encodeURIComponent(response.devResetToken);
        }
      } catch (err) {
        this.error = err.message || 'Не удалось отправить ссылку';
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f6f8fb;
  padding: 24px;
}
.auth-card {
  width: min(460px, 100%);
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 28px;
  background: #fff;
  border: 1px solid #e5eaf2;
  border-radius: 8px;
  text-align: left;
  h1 {
    margin: 0;
    color: #202938;
  }
  a {
    color: #1976d2;
  }
}
.auth-note, .auth-error {
  margin: 0;
}
.auth-note {
  color: #546179;
}
.auth-error {
  color: #c10015;
}
</style>
